// South Jersey local delivery zip prefixes (Camden, Burlington, Gloucester,
// Atlantic, Cape May, Cumberland, Salem). 3-digit prefixes covering NJ South.
export const LOCAL_ZIP_PREFIXES = [
    "080", "081", "082", "083", "084", "085",
];

export function checkZip(zip) {
    if (!zip) return null;
    const clean = String(zip).trim().slice(0, 5);
    if (!/^\d{5}$/.test(clean)) return { status: "invalid", message: "Enter a 5-digit zip code." };
    const prefix = clean.slice(0, 3);
    if (LOCAL_ZIP_PREFIXES.includes(prefix)) {
        return {
            status: "local",
            message: "Local delivery available — same-day on most orders.",
            zip: clean,
        };
    }
    return {
        status: "out_of_area",
        message: "Sorry — we deliver locally in South Jersey only.",
        zip: clean,
    };
}
